import PropTypes from 'prop-types'

import { Cancel } from '@/components/Icons'

const FilterTag = ({ textAsString, onClose }: any) => {
  return (
    <div className="tag">
      <p>{`${textAsString}`}</p>
      {/* TODO Remove this onClick and wrap it in a button */}
      <Cancel onClick={onClose} style={{ color: '#666666' }} />
    </div>
  )
}

FilterTag.displayName = 'FilterTag'

FilterTag.defaultProps = {
  textAsString: 'test'
}

FilterTag.propTypes = {
  textAsString: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired
}

export default FilterTag
